import React from 'react';
import { useAuthStore } from '@/store/authStore';
import { User, Shield, Calendar, AtSign, LogOut } from 'lucide-react';
import PageHeader from '@/components/PageHeader';

export const ProfilePage: React.FC = () => {
  const { user, isCurator, logout } = useAuthStore();

  const handleLogout = () => {
    logout();
  };

  return (
    <div className="min-h-[100svh] w-full bg-gradient-to-br from-gray-50 via-blue-50/30 to-indigo-100/30 dark:from-gray-900 dark:via-slate-800 dark:to-slate-900">
      <PageHeader
        subtitle="View your account information"
        icon={User}
        iconColor="text-purple-600 dark:text-purple-400"
        iconBgColor="bg-purple-100 dark:bg-purple-900/20"
        showBackButton={false}
        rightContent={
          <button
            onClick={handleLogout}
            className="inline-flex items-center justify-center p-2 border border-transparent rounded-lg shadow-sm text-white bg-gradient-to-r from-red-600 to-red-600 hover:from-red-700 hover:to-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-all duration-200 transform hover:scale-105"
            title="Logout"
          >
            <LogOut className="h-5 w-5" />
          </button>
        }
      />
      <div 
        className="w-full py-3 sm:pb-3 overflow-y-auto h-[100svh]"
        style={{
          paddingTop: 'var(--header-height, 80px)'
        }}
      >

        {/* Profile Information - compact vertical list, no rounded corners */}
        <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 p-4 sm:p-5">
          <div className="flex items-center mb-4">
            <div className="p-2 bg-blue-100 dark:bg-blue-900/20 mr-3">
              {isCurator() ? (
                <Shield className="h-6 w-6 text-blue-600 dark:text-blue-400" />
              ) : (
                <User className="h-6 w-6 text-blue-600 dark:text-blue-400" />
              )}
            </div>
            <div>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
                {user?.name || 'User'}
              </h2>
              <p className="text-xs text-gray-600 dark:text-gray-400 mt-0.5 capitalize">
                {isCurator() ? 'Curator' : 'Student'}
              </p>
            </div>
          </div>

          <div className="divide-y divide-gray-200 dark:divide-gray-700">
            <div className="py-3 flex items-center justify-between">
              <div className="flex items-center text-gray-500 dark:text-gray-400 text-xs">
                <AtSign className="h-4 w-4 mr-2" />
                Username
              </div>
              <div className="text-sm text-gray-900 dark:text-white truncate max-w-[60%]">
                {user?.username || 'N/A'}
              </div>
            </div>

            <div className="py-3 flex items-center justify-between">
              <div className="flex items-center text-gray-500 dark:text-gray-400 text-xs">
                <User className="h-4 w-4 mr-2" />
                Full Name
              </div>
              <div className="text-sm text-gray-900 dark:text-white truncate max-w-[60%]">
                {user?.name || 'N/A'}
              </div>
            </div>

            <div className="py-3 flex items-center justify-between">
              <div className="flex items-center text-gray-500 dark:text-gray-400 text-xs">
                <Shield className="h-4 w-4 mr-2" />
                Role
              </div>
              <div className="text-sm text-gray-900 dark:text-white capitalize">
                {user?.role || 'N/A'}
              </div>
            </div>

            <div className="py-3 flex items-center justify-between">
              <div className="flex items-center text-gray-500 dark:text-gray-400 text-xs">
                <Calendar className="h-4 w-4 mr-2" />
                Member Since
              </div>
              <div className="text-sm text-gray-900 dark:text-white">
                {user?.created_at ? new Date(user.created_at).toLocaleDateString() : 'N/A'}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;


